import React from 'react';
import { Link } from 'react-router-dom';
import useMeta from '../hooks/useMeta';

export default function NotFound() {
  useMeta(
    'Siden blev ikke fundet - Danry Diamant Boring ApS',
    'Den søgte side findes desværre ikke. Gå tilbage til forsiden af Danry Diamant Boring ApS.'
  );

  return (
    <div className="pt-[90px] lg:pt-[120px] min-h-[calc(100vh-120px)] flex items-center justify-center bg-white relative overflow-hidden py-20">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-brand-orange/5 rounded-full blur-[80px] pointer-events-none" />

      <div className="max-w-md w-full px-6 text-center flex flex-col items-center gap-6 relative z-10">
        <div className="w-20 h-20 rounded-2xl bg-brand-orange/10 border border-brand-orange/20 flex items-center justify-center text-brand-orange text-4xl shadow-lg shadow-brand-orange/5 animate-bounce">
          <i className="fa-solid fa-triangle-exclamation" />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="text-7xl font-extrabold text-neutral-900 tracking-tight uppercase">404</h1>
          <h2 className="text-2xl font-bold text-neutral-900 uppercase">Siden blev ikke fundet</h2>
          <p className="text-sm text-neutral-600 leading-relaxed mt-2">
            Vi kan desværre ikke finde den side, du leder efter. Den er muligvis blevet flyttet, slettet eller har aldrig eksisteret.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full mt-4">
          <Link
            to="/"
            className="flex-1 py-3 rounded-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-sm transition-colors shadow-md shadow-brand-orange/10 text-center"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="flex-1 py-3 rounded-full bg-neutral-100 hover:bg-neutral-200 border border-neutral-200 text-neutral-800 font-bold text-sm transition-colors text-center"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
